import { api } from './client'
import type {
  ApplicationInfo, AttemptView, ConsentView, Details, GuardianLinkView, IntegrityEvent, MyReport, MyResults, NextAssessment, PublicCampaign, PublicConfig, RegisterResult, RegistrationForm, SaveBody, TokenResponse,
} from './types'

export const INSTITUTION = import.meta.env.VITE_INSTITUTION ?? 'vu'

export const requestOtp = (email: string, institution: string = INSTITUTION) =>
  api<void>('/api/auth/otp/request', { method: 'POST', body: { institution, email } })
export const verifyOtp = (email: string, code: string, institution: string = INSTITUTION) =>
  api<TokenResponse>('/api/auth/otp/verify', { method: 'POST', body: { institution, email, code } })

export const getApplication = () => api<ApplicationInfo>('/api/me/application')
export const getRegistrationForm = () => api<RegistrationForm>('/api/me/registration-form')
export const saveProfile = (d: Details) => api<void>('/api/me/profile', { method: 'PUT', body: d })

export const getCampaign = (institution: string, slug: string) => api<PublicCampaign>(`/api/public/campaigns/${encodeURIComponent(institution)}/${encodeURIComponent(slug)}`)
export const registerForCampaign = (institution: string, slug: string, body: unknown) =>
  api<RegisterResult>(`/api/public/campaigns/${encodeURIComponent(institution)}/${encodeURIComponent(slug)}/register`, { method: 'POST', body })
export const getPublicConfig = () => api<PublicConfig>('/api/public/config')
export const getMyResults = () => api<MyResults>('/api/me/results')

export const getConsent = () => api<ConsentView>('/api/me/consent')
export const giveConsent = (consentVersion: string) =>
  api<void>('/api/me/consent', { method: 'POST', body: { consentVersion } })
export const requestGuardian = () => api<void>('/api/me/consent/guardian-request', { method: 'POST' })

export const getGuardianLink = (token: string) => api<GuardianLinkView>(`/api/consent/${encodeURIComponent(token)}`)
export const giveGuardianConsent = (token: string, consentVersion: string, guardianName: string) =>
  api<void>(`/api/consent/${encodeURIComponent(token)}`, { method: 'POST', body: { consentVersion, guardianName } })

export const touchPoints = () => (typeof navigator === 'undefined' ? 0 : navigator.maxTouchPoints ?? 0)
/** 204 (nothing left to take) becomes null: TanStack Query does not allow undefined as query data. */
export const getNextAssessment = () =>
  api<NextAssessment | undefined>(`/api/me/next-assessment?touchPoints=${touchPoints()}`).then((r) => r ?? null)
export const startAttempt = () => api<AttemptView>('/api/attempts', { method: 'POST', body: { touchPoints: touchPoints() } })
export const getAttempt = (id: number) => api<AttemptView>(`/api/attempts/${id}`)
export const saveResponse = (attemptId: number, questionId: number, body: SaveBody) =>
  api<{ status: 'SAVED' | 'STALE' }>(`/api/attempts/${attemptId}/responses/${questionId}`, { method: 'PUT', body })
export const postIntegrityEvents = (attemptId: number, events: IntegrityEvent[]) =>
  api<void>(`/api/attempts/${attemptId}/events`, { method: 'POST', body: { events } })
export const submitAttempt = (id: number) =>
  api<AttemptView>(`/api/attempts/${id}/submit`, { method: 'POST', body: { touchPoints: touchPoints() } })

export const getMyReport = () => api<MyReport>('/api/me/report')
